// Module
var code = "<h3>My Wills</h3> <div class=\"listingTableContainer\"> <table id=\"myWillsTable\"> <thead id=\"myWillsTableHead\"></thead> <tbody id=\"myWillsTableBody\"></tbody> </table> </div> <div class=\"text-sm text-gray-600 mt-2 text-right\"> <span id=\"myWillsTotalRecordsDisplay\">-</span> records </div> ";
// Exports
export default code;